<template>
    <div class="container">
        <div @click="goback" style="font-size:14px;margin-bottom:10px;cursor: pointer;width:50px">
            <i class="el-icon-back"></i>
            返回
        </div>
        <el-form ref="formRef" :model="form" label-width="auto" style="margin: auto;max-width: 80%;" size="small"
            :rules="rules">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item label="Banner名称" prop="name">
                        <el-input v-model="form.name" />
                    </el-form-item>
                    <el-form-item label="地址类型">
                        <el-select v-model="form.click_type" placeholder="请选择地址类型" clearable>
                            <el-option label="内部" :value="1" />
                            <el-option label="外部" :value="2" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="跳转地址">
                        <el-input v-model="form.click_url" />
                    </el-form-item>
                    <el-form-item label="开始时间" prop="begin_time">
                        <el-date-picker v-model="form.begin_time" type="datetime" placeholder="请选择开始时间"
                            format="YYYY-MM-DD HH:mm:ss(Z)" value-format="X" style="width: 100%" />
                    </el-form-item>
                    <el-form-item label="结束时间" prop="end_time">
                        <el-date-picker v-model="form.end_time" type="datetime" placeholder="请选择结束时间"
                            format="YYYY-MM-DD HH:mm:ss(Z)" value-format="X" style="width: 100%" />
                    </el-form-item>
                    <el-form-item label="规则" prop="rule_code">
                        <el-select v-model="form.rule_code" placeholder="请选择规则">
                            <el-option v-for="(item) in ruleList" :key="item.code" :label="item.name"
                                :value="item.code" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="区域" prop="region">
                        <el-select v-model="form.region" placeholder="请选择区域">
                            <el-option label="中国" value="cn" />
                            <el-option label="美洲" value="us" />
                            <el-option label="欧洲" value="eu" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="位置" prop="location">
                        <el-select v-model="form.location" placeholder="请选择位置">
                            <el-option label="首页" value="home" />
                            <el-option label="事件" value="event" />
                            <el-option label="直播" value="live" />
                            <el-option label="配网" value="pairing" />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="AB对照组总数" prop="variant_total">
                        <el-input-number v-model="form.variant_total" :min="0" controls-position="right"
                            placeholder="0或1表示不分流" style="width: 100%" />
                    </el-form-item>
                    <el-form-item label="AB对照组序号" prop="variant_index">
                        <el-input-number v-model="form.variant_index" :min="0" controls-position="right"
                            placeholder="从0开始，必须小于总数" style="width: 100%" />
                    </el-form-item>
                    <el-form-item label="内容" prop="contents">
                        <el-row v-for="(v, i) in form.contents" :key="i" style="margin-bottom: 8px;" :gutter="20">
                            <el-col :span="12">
                                <el-select v-model="v.language" placeholder="请选择语言并上传图片">
                                    <el-option v-for="(item, index) in languageList" :key="index" :label="item.name"
                                        :value="item.code" />
                                </el-select>
                            </el-col>
                            <el-col :span="12" style="display: flex;">
                                <el-upload :ref="el => { if (el) uploadRefs[i] = el }" action="" :auto-upload="false"
                                    v-model:file-list="fileLists[i]" :on-change="handleFileChange(i)"
                                    :on-exceed="handleExceed(i)" :limit="2" accept="image/*" style="display: flex;">
                                    <span v-if="fileLists[i] && fileLists[i].length < 2"
                                        style="color: rgb(64, 158, 255);font-size: 24px;"><i class="el-icon-upload"
                                            size="24"></i></span>
                                    <template #file="{ file }">
                                        <div style="border: 1px dashed #cdd0d6;">
                                            <img class="el-upload-list__item-thumbnail" :src="convertFileUrl(file)"
                                                alt="" />
                                            <span class="el-upload-list__item-actions">
                                                <span class="el-upload-list__item-preview"
                                                    @click="handlePictureCardPreview(file)">
                                                    <i class="el-icon-zoom-in"></i>
                                                </span>
                                                <span class="el-upload-list__item-delete"
                                                    @click="handleRemove(i, file)">
                                                    <i class="el-icon-delete"></i>
                                                </span>
                                            </span>
                                        </div>
                                    </template>
                                </el-upload>
                                <span v-if="i === form.contents.length - 1">
                                    <span
                                        style="font-size: 24px; color: rgb(64, 158, 255); cursor: pointer;margin-right: 8px;margin-left: 8px;"
                                        @click="addLanguage">
                                        <i class="el-icon-circle-plus"></i>
                                    </span>
                                    <span style="font-size: 24px; color: #f56c6c; cursor: pointer"
                                        @click="subtractLanguage(i)" v-if="form.contents.length > 1">
                                        <i class="el-icon-remove"></i>
                                    </span>
                                </span>
                                <span v-else style="font-size: 24px; color: #f56c6c; margin-left: 8px;cursor: pointer"
                                    @click="subtractLanguage(i)">
                                    <i class="el-icon-remove"></i>
                                </span>
                            </el-col>
                        </el-row>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button type="primary" size="small" @click="onSubmit(formRef)">确定</el-button>
            </el-form-item>
        </el-form>
        <el-dialog v-model="dialogVisible">
            <div style="display: flex;justify-content: center;align-items: center;">
                <img :src="dialogImageUrl" alt="Preview Image" style="max-width: 80%;" />
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { reactive, onMounted, ref, onBeforeUpdate, watch, toRaw } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessage } from 'element-plus'
import api from '../../../../axios/api'
import util, { convertDateToTimestamp } from '../../../../util/util'
import axios from 'axios'

export default {
    setup() {
        const router = useRouter()
        const route = useRoute()
        const form = reactive({
            code: '',
            name: '',
            begin_time: '',
            end_time: '',
            click_type: '',
            click_url: '',
            rule_code: '',
            region: '',
            location: 'home',
            variant_index: '',
            variant_total: '',
            contents: [
                {
                    language: 'en',
                    content: '',
                    content_second: ''
                }
            ]
        })
        const formRef = ref()
        const languageList = ref([])
        const dialogImageUrl = ref('')
        const dialogVisible = ref(false)
        const uploadRefs = ref([])
        const fileLists = ref([[]])
        const uploadTasks = new Map()
        const rules = reactive({
            name: [
                { required: true, message: '请输入banner名称', trigger: 'blur' }
            ],
            begin_time: [
                {
                    required: true, validator: (r, v, cb) => {
                        if (form.end_time && convertDateToTimestamp(v) > convertDateToTimestamp(form.end_time)) {
                            cb(new Error('开始时间不能大于结束时间'))
                        } else {
                            if (!form.begin_time) {
                                cb(new Error('请选择开始时间'))
                            } else {
                                cb()
                            }
                        }
                    }, trigger: 'blur'
                }
            ],
            end_time: [
                {
                    required: true, validator: (r, v, cb) => {
                        if (form.begin_time && convertDateToTimestamp(v) < convertDateToTimestamp(form.begin_time)) {
                            cb(new Error('结束时间不能小于开始时间'))
                        } else {
                            if (!form.end_time) {
                                cb(new Error('请选择结束时间'))
                            } else {
                                cb()
                            }
                        }
                    }, trigger: 'blur'
                }
            ],
            rule_code: [
                { required: true, message: '请选择规则', trigger: 'change' }
            ],
            region: [
                { required: true, message: '请选择区域', trigger: 'change' }
            ],
            variant_index: [
                {
                    validator: (r, v, cb) => {
                        if (v === '' || v === null || v === undefined) {
                            cb()
                            return
                        }
                        const total = form.variant_total
                        if (total === '' || total === null || total === undefined) {
                            cb(new Error('请先填写AB对照组总数'))
                        } else if (Number(total) <= 1) {
                            // 0 或 1 表示不分流，序号无需小于总数
                            cb()
                        } else if (Number(v) >= Number(total)) {
                            cb(new Error('AB对照组序号必须小于总数'))
                        } else {
                            cb()
                        }
                    }, trigger: 'change'
                }
            ],
            contents: [
                {
                    required: true, validator: (r, v, cb) => {
                        let isValid = 0
                        for (let i = 0; i < v.length; i++) {
                            const e = v[i]
                            if (!e.language || (!e.content && !e.content_second)) {
                                isValid = 1
                                break
                            }
                        }
                        if (isValid === 1) {
                            cb(new Error("不能为空"))
                        } else {
                            cb()
                        }
                    }, trigger: 'blur'
                }
            ]
        })
        const ruleList = ref([])

        console.log('route -->', route)

        // 获取语言列表
        const getLanguageList = async () => {
            const res = await api.LanguageList({
                page: 1,
                limit: 500
            })
            if (res.data.code == 200) {
                languageList.value = res.data.data.data
                return
            }
        }

        // 获取规则列表
        const getContentManageRuleList = async () => {
            const res = await api.ContentManageRuleList({ page: 1, limit: 500 })
            if (res.data.code === 200) {
                const { list } = res.data.data
                ruleList.value = list
            } else {
                ElMessage.error('查询失败: ' + res.msg)
            }
        }

        const addLanguage = () => {
            form.contents.push({
                language: 'en',
                content: '',
                content_second: ''
            })
            fileLists.value.push([])
        }

        const subtractLanguage = (i) => {
            form.contents.splice(i, 1)
            fileLists.value.splice(i, 1)
        }

        const onSubmit = async (formEl) => {
            if (!formEl) return

            if (uploadTasks.size > 0) {
                ElMessage.info('图片正在上传中，请稍候')
                await Promise.all(uploadTasks.values())
            }

            await formEl.validate(async (valid, fields) => {
                if (valid) {
                    const toRawForm = JSON.parse(JSON.stringify(toRaw(form)))
                    toRawForm.begin_time = convertDateToTimestamp(toRawForm.begin_time)
                    toRawForm.end_time = convertDateToTimestamp(toRawForm.end_time)
                    if (!toRawForm.click_type) {
                        delete toRawForm.click_type
                    }
                    if (toRawForm.variant_index === '' || toRawForm.variant_index === null) {
                        delete toRawForm.variant_index
                    }
                    if (toRawForm.variant_total === '' || toRawForm.variant_total === null) {
                        delete toRawForm.variant_total
                    }
                    console.log('toRawForm --> ', toRawForm)
                    const res = await api.ContentManageBannerAdd(toRawForm)
                    if (res.data.code == 200) {
                        ElMessage.success('成功')
                        router.go(-1)
                    } else {
                        ElMessage.error(res.data.msg)
                    }
                } else {
                    console.log('error submit!', fields)
                }
            })
        }

        const goback = () => {
            router.go(-1)
        }

        const handleRemove = (i, file) => {
            fileLists.value[i] = fileLists.value[i].filter(f => f.uid !== file.uid)
        }

        const handlePictureCardPreview = (uploadFile) => {
            dialogImageUrl.value = convertFileUrl(uploadFile)
            dialogVisible.value = true
        }

        const handleExceed = (index) => {
            return (files) => {
                console.log('handleExceed --> ', index, files)
                ElMessage.warning('最多上传两张图片')
            }
        }

        const convertFileUrl = (file) => {
            return file.url ? file.url : URL.createObjectURL(file.raw)
        }

        const fileUpload = async (raw, put_url) => {
            try {
                const config = {
                    headers: {
                        'Content-Type': raw.type,
                        'X-Amz-Acl': 'public-read',
                        'X-Amz-Server-Side-Encryption': "AES256"
                    }
                }
                const urlReg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/
                const url = '/aws' + put_url.split(urlReg.exec(put_url)[0])[1]
                const res = await axios.put(url, raw, config)
                if (res.status !== 200) {
                    throw new Error('上传到S3失败')
                }
            } catch (error) {
                throw new Error('上传失败:' + error.message)
            }
        }

        const syncContent = (index, files = fileLists.value[index] || []) => {
            if (!form.contents[index]) return
            form.contents[index].content = files[0]?.key || ''
            form.contents[index].content_second = files[1]?.key || ''
        }

        const handleFileChange = (index) => {
            return (file) => {
                const { raw } = file
                if (!raw) return

                const uploadTask = new Promise(resolve => {
                    util.getFileMD5(raw, async md5 => {
                        try {
                            const params = {
                                key_action: 'content_page',
                                key_md5: md5,
                                key_type: 'display',
                                key_suffix: raw.name.split('.').pop(),
                                content_length: raw.size,
                                content_type: raw.type
                            }
                            const res = await api.S3push(params)
                            if (res.data.code == 200) {
                                const urlReg = /[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+\.?/
                                const url = '/aws' + res.data.data.get_url.split(urlReg.exec(res.data.data.get_url)[0])[1]
                                await fileUpload(raw, res.data.data.put_url)
                                const files = fileLists.value[index] || []
                                const fileIndex = files.findIndex(item => item.uid === file.uid)
                                const uploadedFile = { ...file, url, key: res.data.data.key }
                                if (fileIndex === -1) {
                                    // Element Plus 旧版可能尚未把 file-list 回写到 v-model。
                                    fileLists.value[index] = [...files, uploadedFile].slice(0, 2)
                                } else {
                                    const updatedFiles = [...files]
                                    updatedFiles[fileIndex] = uploadedFile
                                    fileLists.value[index] = updatedFiles
                                }
                                // 上传完成后直接同步，避免依赖上传组件内部对象触发监听。
                                syncContent(index)
                                return
                            }
                            ElMessage.error('预签名失败' + res.data.msg)
                        } catch (error) {
                            ElMessage.error(error.message || '上传失败')
                        } finally {
                            resolve()
                        }
                    })
                })
                uploadTasks.set(file.uid, uploadTask)
                uploadTask.then(() => {
                    if (uploadTasks.get(file.uid) === uploadTask) {
                        uploadTasks.delete(file.uid)
                    }
                })
            }
        }

        // 监听fileLists的变化，把两张图片同步到form.contents
        watch(fileLists, (newVal) => {
            newVal.forEach((item, index) => {
                syncContent(index, item)
            })
        }, { deep: true })

        onBeforeUpdate(() => {
            uploadRefs.value = []
        })

        onMounted(() => {
            getLanguageList()
            getContentManageRuleList()
            const code = route.params.code
            if (code && code !== '0') {
                api.ContentManageBannerDetail({ code }).then(res => {
                    if (res.data.code === 200) {
                        Object.assign(form, res.data.data)
                        form.begin_time = res.data.data.begin_time * 1000
                        form.end_time = res.data.data.end_time * 1000
                        form.click_type = res.data.data.click_type ? res.data.data.click_type : ''
                        fileLists.value = res.data.data.contents.map((item, index) => {
                            const arr = []
                            if (item.content) {
                                arr.push({ uid: `content-${index}`, url: item.content.includes('aws') ? item.content : `/aws/${item.content}`, key: item.content })
                            }
                            if (item.content_second) {
                                arr.push({ uid: `content-second-${index}`, url: item.content_second.includes('aws') ? item.content_second : `/aws/${item.content_second}`, key: item.content_second })
                            }
                            return arr
                        })
                    } else {
                        ElMessage.error('获取详情失败: ' + res.data.msg)
                    }
                }).catch(err => {
                    console.error('获取详情失败:', err)
                    ElMessage.error('获取详情失败')
                })
            }
        })

        return {
            form,
            addLanguage,
            subtractLanguage,
            onSubmit,
            goback,
            languageList,
            dialogImageUrl,
            dialogVisible,
            handleRemove,
            handlePictureCardPreview,
            handleExceed,
            uploadRefs,
            fileLists,
            convertFileUrl,
            handleFileChange,
            fileUpload,
            rules,
            formRef,
            ruleList

        }
    }
}
</script>

<style scoped language="stylus" rel="stylesheet/stylus">
.container {
    .el-upload-list__item-thumbnail {
        width: 80px;
        height: 40px;
        object-fit: contain;
        display: block;
    }

    .el-upload-list__item-actions {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        cursor: default;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        color: #fff;
        opacity: 0;
        font-size: 20px;
        background-color: rgba(0, 0, 0, .5);
        transition: opacity .3s;
    }

    .el-upload-list__item-actions:hover {
        opacity: 1;
    }

    .el-upload-list__item-actions:hover span {
        display: inline-flex;
    }

    .el-upload-list__item-actions span {
        display: none;
        cursor: pointer;
    }

    .el-upload-list__item-actions:hover span {
        display: inline-flex;
    }

    .el-upload-list__item-actions .el-upload-list__item-delete {
        position: static;
        font-size: inherit;
        color: inherit;
    }

    .el-upload-list__item-actions span+span {
        margin-left: 16px;
    }

    .el-upload-list__item-delete {
        position: absolute;
        right: 10px;
        top: 0;
        font-size: 12px;
        color: '#606266';
        display: none;
    }

    ::v-deep(.el-upload-list__item:first-child) {
        margin-top: 0;
    }

    ::v-deep(.el-upload-list) {
        margin-left: 10px;
        display: flex;
        flex-wrap: nowrap;
    }

    ::v-deep(.el-upload-list__item) {
        margin-top: 0;
        margin-right: 8px;
    }
}
</style>
<style>
.el-upload-list__item {
    transition: none !important;
}
</style>
